import entitiesSelector from './entities_selector';

const meetingsSelector = entitiesSelector(
  state => state.meetings,
  (meeting, localState, associations) => {
    return {
      noninstructional: !meeting.instructional && meeting.name !== 'Prep'
    };
  }
);

export default meetingsSelector;


/** WEBPACK FOOTER **
 ** ./src/js/selectors/meetings_selector.js
 **/